<template>
  <div class="login">
    <Title titleName='自动报价' iconLeft="back"/>
	

			<div class="card-color">
				<div class="leaf">
					<div class="dont">
						开启自动接单
					</div>
					<div class="fit">
						<van-switch size="22" v-model="taking_auto"  @change="mode" active-color="#FF5E00" inactive-color="#dcdee0" />
						
					</div>
				</div>
				<div class="leaf" @click="need=true">
					
						<div class="dont">
							设置报价时间段
						</div>
						<div class="fit">
							<span v-if="taking_time">{{taking_time}}</span>
							<img v-else src="../../assets/ip.png" />
						
						</div>
				
				</div>
			
			
			
			</div>
	
	<div class="mem-l2">
				<div class="tit">
				<img src="../../assets/y5.png" />	<h3>已设置规则</h3>
				
				</div>
				<ul>
					<li v-for="item in rule">
						<div class="txt">
							市场价:{{item.market_left}}-{{item.market_right}}; 包含影院:{{item.contain_cinema}}; 不包含影院:{{item.un_contain_cinema}}; 包含影片:{{item.contain_movie}};不包含影片:{{item.un_contain_movie}}; 包含影厅:{{item.contain_hall}}; 不包含影厅:{{item.un_contain_hall}};情侣座:<span v-if="item.lovers_seat==0">可含情侣座</span><span v-if="item.lovers_seat==1">不含情侣座</span>; 接受调坐:<span v-if="item.accept_seats==0">不可调座</span><span v-if="item.accept_seats==1">可调座</span>; 座位数量:<span v-if="item.seats_number==0">不限</span><span v-if="item.seats_number==1">单数</span><span v-if="item.seats_number==2">双数</span>;  报价模式:<span v-if="item.offer_type==1">比例报价</span><span v-if="item.offer_type==2">市场价报价</span><span v-if="item.offer_type==3">最高价减法报价</span><span v-if="item.offer_type==4">固定金额报价</span>; 状态:<span v-if="item.state==0">禁用</span><span v-if="item.state==1">启用</span>
						</div>
						<router-link :to="'sub?id='+item.id">
						<img src="../../assets/y6.png" />
						</router-link>
					</li>
				
				</ul>
			</div>
			<router-link to="sub">
		<div class="hb-button">添加新规则</div>
		</router-link>
		<van-popup v-model="need" position="bottom" >
	 <van-datetime-picker
	   v-model="pat1"
	   @confirm="onConfirm"
	   @cancel="need = false"
	   type="time"
	   title="开始时间"
	 />
	 </van-popup> 
	 <van-popup v-model="meet" position="bottom">
	 <van-datetime-picker
	   v-model="pat2"
	   @confirm="leader"
	   @cancel="meet = false"
	   type="time"
	   title="结束时间"
	 />
	 </van-popup> 
  </div>
</template>
<script>
import Title from "@/common/title";
import Bar from '@/components/bar/bar'
import { Toast } from 'vant';	
export default {
  components: {
    Title,
    Bar

  },
  data() {
    return {
		need:false,
		meet:false,
		taking_auto:false,
		rule:'',
		user:'',
		pat1: '',
		pat2: '',
		taking_time:'',
		file:'',
		user:'',
		ruleForm:{
			email:'',
			password:''
		}
    
    };
  },mounted() {
  this.funder()
this.sandMate();
  },methods:{
	  onConfirm() {
	 
	      this.need = false;
		  this.meet = true
	     },
	sandMate(){
		this.$axios({
		  method: "post",
		  url: "stores/info",
		  data: {},  
		}).then((res) => {
			let data=res.data;
	
			if(data.code==200){
		
								
				this.user=data.data.store_info;
				if(this.user.store_info.taking_auto==1){
					this.taking_auto=true
				}else{
					this.taking_auto=false
				}
				
					
				
			}
		 
		});
	
	},
	funder(){
		this.$axios({
		  method: "get",
		  url: "stores/rule_list"
		}).then((res) => {
			let data=res.data;
					
			if(data.code==200){
			  						
			  	this.rule=data.data
						
			    
				
			}
		 
		});
			  				 
	},leader(){
		this.meet=false
		this.taking_time=this.pat1+'-'+this.pat2
		this.green()
	}
	,mode() {
				
	          this.$axios({
	            method: "post",
	            url: "stores/mode",
	            data: {taking_auto:this.taking_auto,taking_time:this.taking_time}
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				
	    
	          		
	          	}else{  
	  			 Toast(data.message);
	  						      
	  			}
	           
	          });
	  				 
	  				 
	         
	       
	       },green() {
				
	          this.$axios({
	            method: "post",
	            url: "stores/mode",
	            data: {taking_time:this.taking_time}
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				
	    
	          		
	          	}else{  
	  			 Toast(data.message);
	  						      
	  			}
	           
	          });
	  				 
	  				 
	         
	       
	       }
  }
};
</script>
<style lang="scss" scoped>
.login{
	
	h1{
	
		font-size: 32px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
		margin-bottom: 20px;

	}
}
 .pro-tit{
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }

 .mem-l2{
		margin-top: 20px;
 		 background: #FFFFFF;
 		 padding: 30px;
		margin-bottom: 20px;
 		 .tit{
 			 display: flex;
			 align-items: center;
 			 h3{
 				 font-size: 36px;
 				 color: #222222;
 			 }
 			img{
				width: 36px;
				height: 36px;
				margin-right: 10px;
			}
 		 }
 		 ul{
 			
 			 li{
 				display: flex;
				font-size: 24px;
				color: #7D7D7D;
				margin-top: 30px;
				justify-content: space-between;
				.txt{
					width: 600px;
				}
				img{
					width: 36px;
					height: 36px;
				}
 			 }
 			
 		 }
 		 .min{
 		 				 li{
 		 					  width: 25%;
 		 				 }
 		 				
 		 }
 }
 .card-color{
	
	 .leaf{
		 display: flex;
		 justify-content: space-between;
		 align-items: center;
		 border-bottom: 1px solid #eeeeee;
		 padding: 30px 0;
		 padding-right: 30px;
		 padding-left:30px;
		 height: 40px;
		 font-size: 28px;
		 margin-top: 20px;
		 background: #fff;
		 color: #000000;
		 a{
			 display: flex;
			 justify-content: space-between;
			 align-items: center;
			 width: 100%;
			 color: #000000;
		 }
		 .dont{
			 display: flex;
			 align-items: center;
			 img{
				 width: 32px;
				 height: 32px;
				 margin-right: 15px;
			 }
		 }
		 .fit{
			 color: #999999;
			 img{
				 width: 30px;
				 height: 30px;
			 }
		 }
	 }
 }
 .hb-button{
 	margin: 30px;
 	 height: 100px;
 	 background: #FF5E00;
 	 border-radius: 50px;
 	 color: #FFFFFF;
 	 font-size: 28px;
 	 text-align: center;
 	 line-height: 100px;
 
 }
</style>